import { useMutation, useQuery } from "@tanstack/react-query"
import { apiClient } from "@/shared/api/client"

export const useSubscriptionStatus = (enabled: boolean) => {
	return useQuery({
		queryKey: ["subscriptions", "status"],
		queryFn: async () => {
			const { data } = await apiClient.get<{
				hasSubscriptions: boolean
				subscriptions: string[]
				totalChannels: number
			}>("/channels/subscriptions/status")
			return data
		},
		enabled,
		staleTime: 0,
		gcTime: 0,
		refetchOnWindowFocus: true,
		refetchOnReconnect: true,
		refetchOnMount: "always",
	})
}

export const useSyncSubscriptions = () => {
	return useMutation({
		mutationFn: async () => {
			const { data } = await apiClient.post<{
				success: boolean
				subscriptions: string[]
				hasSubscriptions: boolean
			}>("/channels/subscriptions/sync")
			return data
		},
	})
}
